(function () {
  document.querySelectorAll('.main-footer__menu > li > a').forEach(link => {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      if (window.innerWidth < 884) {
        this.classList.toggle('sub-menu-open');
        const subMenu = this.nextElementSibling;

        if (subMenu && subMenu.classList.contains('sub-menu')) {
          if (subMenu.style.maxHeight === '0px' || !subMenu.style.maxHeight) {
            subMenu.style.display = 'block';
            setTimeout(() => {
              subMenu.style.opacity = '1';
              subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
            }, 10);
          } else {
            subMenu.style.opacity = '0';
            subMenu.style.maxHeight = '0px';
            setTimeout(() => {
              subMenu.style.display = 'none';
            }, 300);
          }
        }
      }
    });
  });
})();
